import axios from "axios";

export default function PartnerShowService(id) {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/partner/" + id,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
